import { render } from "./terms_of_service_panel.vue?vue&type=template&id=d59fafc6"
import script from "./terms_of_service_panel.js?vue&type=script&lang=js&external"
export * from "./terms_of_service_panel.js?vue&type=script&lang=js&external"

import "./terms_of_service_panel.vue?vue&type=style&index=0&id=d59fafc6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__